var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { useConfigContext } from '@m4b-design/config-provider';
import { IconDown } from '@arco-design/iconbox-react-m4b-next';
import cx from 'classnames';
import ArcoCollapse from './core';
import Item from './item';
import './style/collapse.less';
var CollapseRender = function (props, ref) {
    var _a;
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-collapse");
    var _b = props.titleSize, titleSize = _b === void 0 ? 'default' : _b, arcoCollapseProps = __rest(props, ["titleSize"]);
    var _c = arcoCollapseProps.bordered, bordered = _c === void 0 ? false : _c, _d = arcoCollapseProps.expandIconPosition, expandIconPosition = _d === void 0 ? 'right' : _d;
    var expandIcon = 'expandIcon' in arcoCollapseProps ? (arcoCollapseProps.expandIcon) : (React.createElement(IconDown, { className: "".concat(prefixCls, "-item-header-expand-icon") }));
    var mergedProps = __assign(__assign({}, arcoCollapseProps), { bordered: bordered, expandIconPosition: expandIconPosition, expandIcon: expandIcon });
    var classNames = cx(prefixCls, (_a = {},
        _a["".concat(prefixCls, "-title-default")] = titleSize === 'default',
        _a["".concat(prefixCls, "-title-small")] = titleSize === 'small',
        _a), mergedProps.className);
    return React.createElement(ArcoCollapse, __assign({}, mergedProps, { className: classNames, ref: ref, "data-tid": "m4b_collapse" }));
};
var ForwardRefCollapse = forwardRef(CollapseRender);
var Collapse = ForwardRefCollapse;
Collapse.displayName = 'Collapse';
Collapse.Item = Item;
export default Collapse;
